import { useEffect, useState } from "react";
import { Crown, Feather, Flame, Shield } from "lucide-react";
import { api } from "../../lib/api";

const ICON = { Herald: Feather, Envoy: Shield, Champion: Flame, Legend: Crown };

export function InviterBoard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/public/inviters").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d || !d.leaders.length) return null;
  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-8 py-16 border-t border-amber-500/15" data-testid="inviter-board">
      <p className="eyebrow mb-3">Our community</p>
      <h2 className="font-display text-3xl mb-2">Top inviting authors</h2>
      <p className="text-sm text-slate-400 mb-8">Authors who brought the most fellow writers into the studio.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {d.leaders.map((l, i) => { const I = ICON[l.badge] || Feather; return (
          <div key={l.rank} className="panel p-4 fade-up" style={{ animationDelay: `${i * 0.05}s` }} data-testid={`inviter-${l.rank}`}>
            <p className="text-xs text-amber-300">#{l.rank}</p>
            <p className="font-display text-lg mt-1">{l.name}</p>
            <p className="inline-flex items-center gap-1 text-[11px] mt-2 px-2 py-0.5 rounded-full border border-amber-500/40 text-amber-100" data-testid={`inviter-badge-${l.rank}`}><I size={11} />{l.badge}</p>
            <p className="text-[11px] text-slate-500 mt-2">{l.invites} author{l.invites === 1 ? "" : "s"} invited</p>
          </div>
        ); })}
      </div>
      <p className="text-[11px] text-slate-500 mt-6" data-testid="inviter-badge-key">{d.badges.map((b) => `${b.name}: ${b.min}+`).join(" · ")}</p>
    </section>
  );
}
